import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { color, font, breakpoint } from '../../constants';

import { InputError } from '../../../premium/Elements/InputError/inputError';


const Form = styled.form`

  button, input {
    font-size: 0.875em;
    padding: 0.75em 1.5em;
    box-sizing: border-box;
    line-height: 1;
  }

  .input-container {
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    width: 66.66666%;
    padding-right: 1em;
  }

  input {
    width: 100%;
    font-family: ${font.GRAPHIK};
    font-weight: 400;
    border-radius: 0.33em;
    border: 1px solid ${color.gray40};
    outline: none;
  }

  button {
    width: 33.33333%;
    text-align: center;
  }

  ${breakpoint.atSmallWidth} {
    button, .input-container {
      width: 100%;
    }

    .input-container {
      margin: 0 0 0.5em;
      padding: 0;
    }
  }

  .input-float {
    box-sizing: border-box;
    width: 100%;
    padding-right: 1em;
    position: absolute;
    bottom: 110%;
    font-size: 0.875em;

    &.hidden {
      display: none;
    }

    ${breakpoint.atSmallWidth} {
      padding: 0;
    }
  }
`

const EmailForm = ({ id, isSubmitting, submitError, onFocus, onChange, onSubmit, }) => {

  const [emailValue, setEmailValue] = useState('');

  function handleFocus(event) {
    onFocus(id);
  }

  function handleEmailChange(event) {
    const newVal = event.target.value;
    setEmailValue(newVal);
    onChange(newVal);
  }

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit(emailValue, id);
  }

  return (
    <Form onSubmit={handleSubmit}>
      <div className="input-container">
        <InputError error={submitError} side="left" hidden={!submitError} />
        <input
          type="text"
          placeholder="Your email address"
          value={emailValue}
          onChange={handleEmailChange}
          onFocus={handleFocus}
          disabled={isSubmitting}
        />
      </div>
      <button
        type="submit"
        disabled={isSubmitting}
      >
        { isSubmitting ? 'Working on it...' : 'Subscribe' }
      </button>
    </Form>
  );
}

EmailForm.propTypes = {
  /**
   * Identifier for the form, which has multiple instances on a screen.
   */
  id: PropTypes.string,

  /**
   * Set to true to display a pending state
   */
  isSubmitting: PropTypes.bool,

  /**
   * Error message, if email is invalid or submission request failed
   */
  submitError: PropTypes.string,

  /**
   * Called when the user focuses on the email input field
   */
  onFocus: PropTypes.func,

  /**
   * Called when the contents of the email field change
   */
  onChange: PropTypes.func,

  /**
   * Callback called when the user submits the form
   */
  onSubmit: PropTypes.func,
};

EmailForm.defaultProps = {
  id: null,
  isSubmitting: false,
  submitError: null,
  onFocus(formId) {},
  onChange(value) {},
  onSubmit(email, formId) {},
};


export default EmailForm